import { getProxiedServiceUrl } from 'gw-portals-url-js';
import { JsonRPCService } from 'gw-portals-transport-js';
import { DocumentUploadService } from 'gw-portals-document-js';

export default class PolicyService {
    static getAccountPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicySummaries', [], authHeader);
    }

    static getUserPolicySummaries(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getUserPolicySummaries', [], authHeader);
    }

    static getAccountPolicyDetails(policyNumber, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountPolicyDetails', [policyNumber], authHeader);
    }

    static removeDocument(publicID, authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('removePolicyDocument'), 'removeDocument', [publicID], authHeader);
    }

    static uploadDocument(document, documentMetadata, authHeader = {}) {
        return DocumentUploadService.send(getProxiedServiceUrl('uploadPolicyDocument'), document, documentMetadata, authHeader);
    }

    static getDocumentUploadToken(params, additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('generateUploadToken'), 'generateUploadToken', params, additionalHeaders);
    }

    static getAccountDocuments(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountDocuments', [], authHeader);
    }

    static getUserDocuments_EY(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getUserDocuments_EY', [], authHeader);
    }

    static getAllAccountDocuments(authHeader = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'), 'getAccountDocs', [], authHeader);
    }

    static getNotesForPolicy(policyNumber, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'getNotesForPolicy', [policyNumber], additionalHeaders);
    }

    static createNoteForPolicy(policyNumber, noteDTO, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'createNoteForPolicy', [policyNumber, noteDTO], additionalHeaders);
    }

    static updateClaimNote(policyNumber, note, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'updateClaimNote', [policyNumber, note], additionalHeaders);
    }

    static deleteClaimNote(policyNumber, noteId, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'deleteClaimNote', [policyNumber, noteId], additionalHeaders);
    }

    static getLiabilitySlip(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'getLiabilitySlip_EY', params, additionalHeaders);
    }

    static updatePolicyDocumentPreference(policiesDocPreferences, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'updatePolicyDocumentPreference', [policiesDocPreferences], additionalHeaders);
    }

    static sendCsioSlipByEmailToCustomer(params, additionalHeaders = {}) {
        return JsonRPCService.send(getProxiedServiceUrl('policy'),'sendCsioSlipByEmailToCustomer', params, additionalHeaders);
    }
}
